export default __webpack_public_path__ + "static/media/g.061908ee.svg";